import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import Button from 'react-bootstrap/Button';
import { useDispatch } from 'react-redux';
import { clearUserRoles } from '../../redux/slices/userSlice';
import { getAppUrl, withRoutePrefix } from '../../config/routePrefix';

const AuthButton = () => {
    const { instance, accounts, inProgress } = useMsal();
    const dispatch = useDispatch();

    // Ensure user session is handled correctly after login
    useEffect(() => {
        const handleRedirect = async () => {
            try {
                const response = await instance.handleRedirectPromise();
                if (response?.account) {
                    //console.log("Login successful: ", response.account);
                    instance.setActiveAccount(response.account);

                    // Nested function to redirect to the stored URL
                    const redirectToStoredUrl = () => {
                        const redirectUrl = sessionStorage.getItem('postAuthRedirectUrl');
                        const rootUrl = window.location.origin; // This is the root URL

                        // If there's a stored URL and it's not the root URL, redirect to it
                        if (redirectUrl && redirectUrl !== rootUrl) {
                            // Redirect to the stored URL and clear it from sessionStorage
                            sessionStorage.removeItem('postAuthRedirectUrl');
                            window.location.href = redirectUrl;
                        } else {
                            // Default redirect if no URL is stored or if it's the root URL
                            window.location.href = withRoutePrefix('/'); // Or any other fallback URL
                        }
                    };

                    // Call the nested redirect function
                    redirectToStoredUrl();
                }
            } catch (error) {
                console.error("Error during handleRedirectPromise: ", error);
            }
        };

        if (inProgress === 'none') {
            handleRedirect();
        }
    }, [instance, accounts, inProgress]);

    // Trigger login and store the user's current location
    const handleLogin = () => {
        if (accounts.length === 0 && inProgress === 'none') {
            // Store the current URL to redirect to after login
            // sessionStorage.setItem("postAuthRedirectUrl", window.location.pathname);

            // Initiate login redirect
            instance.loginRedirect({
                scopes: ["user.read", "openid", "profile", "offline_access"],
                redirectUri: getAppUrl('/'),  // This should match the registered redirect URI in Azure AD
            }).catch(e => {
                console.error("Login failed", e);
            });
        }
    };

    // Handle logout and clear user-specific data
    const handleLogout = () => {
        if (accounts.length > 0) {
            dispatch(clearUserRoles());
            instance.logoutRedirect({
                postLogoutRedirectUri: getAppUrl('/'), // Redirect after logout
            }).catch(e => {
                console.error("Logout failed", e);
            });
        }
    };

    return (
        <div className='authButton'>
            {accounts.length > 0 ? (
                <Button variant='light' onClick={handleLogout}>Logout</Button>
            ) : (
                <Button variant='light' onClick={handleLogin}>Login</Button>
            )}
        </div>
    );
};

export default AuthButton;
